/* VIP Sale 2026 – vip-banner.js (Eigentümer: T2, Stand 19.10.2026).
   Zweck: Headerbar, Banner Startseite/Collection, SALE-Box, Timer, Staffel-Modal, PDP-Staffel, Rabatt-Indikator.
   Eingebunden in layout/theme.liquid (<head>, defer, nach vip-core.js). Liest Phase/Staffel AUSSCHLIESSLICH über
   window.VIP (assets/vip-core.js): phase(), phases, tiers(), tierFor(), nextTierFor(), nextSwitchAt(), now(),
   cartBasisCents(), formatEUR(), onPhase(), onCart(). Keine eigenen Zeitberechnungen, keine zweite Konfiguration –
   Anzeigenamen der Phasen (Landingpage-Wording) sind das Einzige, was hier ergänzt wird (DISPLAY, Fallback = Config-Label).

   Markup-Vertrag (alle Snippets):
     [data-vip-root][data-vip-el="headerbar|home|salebox|pdp|cart"]  Wurzel, bekommt data-vip-state="pre|active|post"
     [data-vip-show="token token …"]   sichtbar, wenn eines der Tokens zutrifft:
                                       pre | active | post | gift | nogift | next | last | t1 | hasnext | top
     [data-vip-slot="name"]            Textslot (label, tiersline, tiersline-dot, maxpct, maxall, t0, t1, t1min, t2, t2min,
                                       nextpct, nextlabel, when, datespan, chips, curpct, missing, saving, progress)
     [data-vip-timer="hms|short|pre|units"]  Countdown bis zum nächsten Phasenwechsel (VIP.nextSwitchAt())
     [data-vip-open-tiers]             öffnet das Staffel-Modal (#vip-tier-modal, snippets/vip-tier-modal.liquid)
     [data-vip-signup]                 Inline-Anmeldung (snippets/vip-signup-inline.liquid) – gleiche Klaviyo-Logik wie sections/mh-vip-popup.liquid
   Stand 20.10. (Update-PDF Markus): Timer überall als Kacheln (data-vip-timer="units", snippets/vip-timer-tiles.liquid;
   Tage-Kachel bei 0 Tagen ausgeblendet), Staffel-Modal als ruhige Tabelle ohne vergangene Phasen, Inline-Anmeldung in der PDP-Box.
   Alles idempotent: bei 'vip:phase' und 'vip:cart' werden die Wurzeln frisch aus dem DOM gelesen (Warenkorb-Snippets
   werden vom Theme serverseitig neu gerendert). */
(function () {
  'use strict';
  if (window.VIPBanner && window.VIPBanner.__init) return;

  /* Einheitliche Phasennamen (QA M3) – einzige Quelle für alle T2-Snippets; Config-Labels dienen nur als Fallback */
  var DISPLAY = { early: 'VIP Early Access', vipday: 'VIP-Day', day2: 'Tag 2', day3: 'Tag 3' };
  var DISPLAY_IN = { early: 'Im VIP Early Access', vipday: 'Am VIP-Day', day2: 'An Tag 2', day3: 'An Tag 3' };
  var TZ = (window.VIP_CONFIG && window.VIP_CONFIG.timezone) || 'Europe/Vienna';
  var nativeFetch = window.fetch; // wie mh-vip-popup: unveränderten fetch merken (Apps wrappen window.fetch später)
  var NBSP = ' ';

  function V() { return window.VIP; }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function txt(el, s) { if (el && el.textContent !== s) el.textContent = s; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function label(p) { return (p && (DISPLAY[p.key] || p.label)) || 'VIP Sale'; }
  function labelShort(p) { return label(p); }
  function labelIn(p) { return (p && (DISPLAY_IN[p.key] || ('Im ' + p.label))) || 'Im VIP Sale'; }
  function pct(n) { return (n == null ? '–' : n) + NBSP + '%'; }
  function eur0(n) { try { return new Intl.NumberFormat('de-DE').format(n) + NBSP + '€'; } catch (e) { return n + NBSP + '€'; } }
  function tierRange(tiers, i) {
    var t = tiers[i], nx = tiers[i + 1];
    if (t.min === 0 && nx) return 'bis ' + eur0(nx.min - 1);
    return 'ab ' + eur0(t.min);
  }
  function tiersLine(tiers, sep) { return (tiers || []).map(function (t, i) { return pct(t.pct) + ' ' + tierRange(tiers, i); }).join(sep); }
  function maxPct(p) { return (p && p.tiers || []).reduce(function (m, t) { return Math.max(m, t.pct); }, 0); }
  function maxAll() { return (V().phases || []).reduce(function (m, p) { return Math.max(m, maxPct(p)); }, 0); }
  function phaseIndex(key) { var ph = V().phases || []; for (var i = 0; i < ph.length; i++) if (ph[i].key === key) return i; return -1; }
  function nextPhase(p) {
    var ph = V().phases || [];
    if (!p) return null;
    if (p.key === 'pre') return ph[0] || null;
    var i = phaseIndex(p.key);
    return i > -1 ? (ph[i + 1] || null) : null;
  }
  function dtf(opts) { opts.timeZone = TZ; return new Intl.DateTimeFormat('de-AT', opts); }
  function fmtDay(ts) { try { return dtf({ day: '2-digit', month: '2-digit' }).format(new Date(ts)); } catch (e) { return ''; } }
  function fmtDayNum(ts) { try { return dtf({ day: 'numeric' }).format(new Date(ts)).replace(/\D/g, ''); } catch (e) { return ''; } }
  function fmtTime(ts) { try { return dtf({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(new Date(ts)); } catch (e) { return ''; } }
  function phaseWhen(p) {
    if (!p || !p.startAt) return '';
    var s = fmtTime(p.startAt), e = fmtTime(p.endAt);
    if (s === '00:00' && e === '23:59') return fmtDay(p.startAt) + ' · ganztägig';
    return fmtDay(p.startAt) + ' · ' + s + '–' + e + ' Uhr';
  }
  function dateSpan() {
    var ph = V().phases || [];
    if (!ph.length) return '';
    var a = ph[0], b = ph[ph.length - 1];
    var monthA = fmtDay(a.startAt), monthB = fmtDay(b.endAt);
    var dA = fmtDayNum(a.startAt);
    if (monthA.slice(-3) === monthB.slice(-3)) return dA + '.–' + monthB; // 25.–27.10.
    return monthA + '–' + monthB;
  }
  function uniqDays(filter) {
    var seen = [], out = [];
    (V().phases || []).forEach(function (p) { if (!filter(p)) return; var d = fmtDay(p.startAt); if (seen.indexOf(d) === -1) { seen.push(d); out.push(d); } });
    return out;
  }
  function joinDays(list) { return list.length > 1 ? list.slice(0, -1).join(', ') + ' und ' + list[list.length - 1] : (list[0] || ''); }
  function giftDays() { return joinDays(uniqDays(function (p) { return !!p.gift; })); }
  function passwordDays() { return joinDays(uniqDays(function (p) { return !!p.password_only; })); }
  function openDay() { var d = uniqDays(function (p) { return !p.password_only; }); return d[0] || ''; }
  function firstStart() { var ph = V().phases || []; return ph[0] ? { day: fmtDay(ph[0].startAt), time: fmtTime(ph[0].startAt) } : { day: '', time: '' }; }

  /* ---------- Timer ---------- */
  function remaining() {
    var at = V().nextSwitchAt();
    if (!at) return null;
    return Math.max(0, at.getTime() - V().now().getTime());
  }
  function parts(ms) {
    var s = Math.floor(ms / 1000);
    return { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60, hTotal: Math.floor(s / 3600) };
  }
  function fmtHMS(ms) { var p = parts(ms); return pad(p.hTotal) + ':' + pad(p.m) + ':' + pad(p.s); }
  function fmtPre(ms) { var p = parts(ms); return (p.d ? p.d + (p.d === 1 ? ' Tag ' : ' Tage ') : '') + pad(p.h) + ':' + pad(p.m) + ':' + pad(p.s); }
  function fmtShort(ms) {
    var p = parts(ms);
    if (p.d >= 1) return p.d + (p.d === 1 ? ' Tag ' : ' Tagen ') + p.h + NBSP + 'Std';
    if (p.hTotal >= 1) return p.hTotal + NBSP + 'Std ' + pad(p.m) + NBSP + 'Min';
    return p.m + NBSP + 'Min ' + pad(p.s) + NBSP + 'Sek';
  }
  function tick() {
    if (!V()) return;
    var ms = remaining();
    $$('[data-vip-timer]').forEach(function (el) {
      var mode = el.getAttribute('data-vip-timer');
      if (mode === 'units') {
        var p = ms === null ? null : parts(ms);
        var dEl = el.querySelector('[data-vip-cd="d"]');
        var hasD = !!dEl;
        if (dEl) {
          // Tage-Kachel nur, wenn mindestens 1 Tag übrig ist (Stunden zählen dann bis 23)
          var unit = dEl.closest('.vip-tile, .vip-cd__unit');
          var showD = !!(p && p.d > 0);
          if (unit && unit.hidden === showD) unit.hidden = !showD;
          txt(el.querySelector('[data-vip-cd-lbl="d"]'), p && p.d === 1 ? 'Tag' : 'Tage');
        }
        txt(el.querySelector('[data-vip-cd="d"]'), p ? pad(p.d) : '–');
        txt(el.querySelector('[data-vip-cd="h"]'), p ? pad(hasD ? p.h : p.hTotal) : '–');
        txt(el.querySelector('[data-vip-cd="m"]'), p ? pad(p.m) : '–');
        txt(el.querySelector('[data-vip-cd="s"]'), p ? pad(p.s) : '–');
        return;
      }
      if (ms === null) { txt(el, '–'); return; }
      if (mode === 'short') txt(el, fmtShort(ms));
      else if (mode === 'pre') txt(el, fmtPre(ms));
      else txt(el, fmtHMS(ms));
    });
  }

  /* ---------- Rendering ---------- */
  function setShow(root, flags) {
    $$('[data-vip-show]', root).forEach(function (el) {
      var want = el.getAttribute('data-vip-show').split(/\s+/);
      var on = false;
      for (var i = 0; i < want.length; i++) if (flags[want[i]]) { on = true; break; }
      el.hidden = !on;
    });
  }
  function slot(root, name, value, html) {
    $$('[data-vip-slot="' + name + '"]', root).forEach(function (el) {
      if (html) { if (el.innerHTML !== value) el.innerHTML = value; } else txt(el, value);
    });
  }
  function chipsHTML(tiers) {
    return (tiers || []).map(function (t, i) {
      return '<span class="vip-chip" data-vip-chip data-min="' + t.min + '"><b>' + esc(pct(t.pct)) + '</b><span>' + esc(tierRange(tiers, i)) + '</span></span>';
    }).join('');
  }
  function fillPhase(root, p) {
    var t = p.tiers || [], nx = nextPhase(p);
    var state = p.active ? 'active' : p.key;
    root.setAttribute('data-vip-state', state);
    var flags = {
      active: !!p.active, pre: p.key === 'pre', post: p.key === 'post',
      gift: !!(p.active && p.gift), nogift: !!(p.active && !p.gift),
      next: !!(p.active && nx), last: !!(p.active && !nx),
      t1: t.length > 1
    };
    // Warenkorb-Tokens bleiben erhalten (werden in fillCart gesetzt)
    if (root.getAttribute('data-vip-el') === 'cart') { flags.hasnext = root.__vipHasNext === true; flags.top = root.__vipTop === true; }
    setShow(root, flags);
    slot(root, 'label', label(p));
    slot(root, 'labelin', labelIn(p));
    slot(root, 'tiersline', tiersLine(t, ' | '));
    slot(root, 'tiersline-dot', tiersLine(t, ' · '));
    slot(root, 'maxpct', pct(maxPct(p)));
    slot(root, 'maxall', pct(maxAll()));
    slot(root, 't0', pct(t[0] ? t[0].pct : null));
    slot(root, 't1', pct(t[1] ? t[1].pct : null));
    slot(root, 't1min', t[1] ? eur0(t[1].min) : '');
    slot(root, 't2', pct(t[2] ? t[2].pct : null));
    slot(root, 't2min', t[2] ? eur0(t[2].min) : '');
    slot(root, 'nextpct', nx && nx.tiers && nx.tiers[0] ? pct(nx.tiers[0].pct) : '');
    slot(root, 'nextlabel', nx ? label(nx) : '');
    // QA M2: Folgephase am selben Tag (early -> vipday) heisst "Ab 10:01 Uhr", sonst "Morgen"
    slot(root, 'nextlead', nx ? (fmtDay(nx.startAt) === fmtDay(p.startAt) ? 'Ab ' + fmtTime(nx.startAt) + ' Uhr' : 'Morgen') : '');
    slot(root, 'when', phaseWhen(p));
    slot(root, 'datespan', dateSpan());
    slot(root, 'giftdays', giftDays());
    slot(root, 'pwdays', passwordDays());
    slot(root, 'openday', openDay());
    slot(root, 'firstday', firstStart().day);
    slot(root, 'firsttime', firstStart().time);
    slot(root, 'giftmin', eur0((V().config.gift && V().config.gift.threshold) || 1000));
    slot(root, 'chips', chipsHTML(t), true);
    var el = root.getAttribute('data-vip-el');
    if (el !== 'cart') root.hidden = (p.key === 'post' && el !== 'home');
    root.classList.toggle('is-post', p.key === 'post');
    highlightChips(root);
  }
  function highlightChips(root) {
    var basis = V().cart ? V().cartBasisCents(V().cart) : 0;
    var tier = basis > 0 ? V().tierFor(basis) : null;
    $$('[data-vip-chip]', root).forEach(function (c) {
      c.classList.toggle('is-current', !!(tier && Number(c.getAttribute('data-min')) === tier.min));
    });
  }
  function renderPhase() {
    if (!V()) return;
    var p = V().phase();
    $$('[data-vip-root]').forEach(function (root) { try { fillPhase(root, p); } catch (e) { console.warn('[VIP] banner render', e); } });
    buildModal(p);
    tick();
    renderCart(V().cart, null);
  }

  /* ---------- Warenkorb-Indikator ---------- */
  function fillCart(root, p, basis) {
    var tier = basis > 0 ? V().tierFor(basis) : null;
    var nx = basis > 0 ? V().nextTierFor(basis) : null;
    var show = !!(p.active && basis > 0 && tier);
    root.__vipHasNext = show && !!nx;
    root.__vipTop = show && !nx;
    root.hidden = !show;
    if (!show) return;
    slot(root, 'curpct', pct(tier.pct));
    slot(root, 'label', label(p));
    slot(root, 'labelshort', labelShort(p));
    slot(root, 'missing', nx ? V().formatEUR(nx.missingCents) : ''); // Markus 21.10.: nicht runden – exakt auf den Cent
    slot(root, 'nextpct', nx ? pct(nx.pct) : '');
    slot(root, 'saving', V().formatEUR(Math.round(basis * tier.pct / 100)));
    slot(root, 'saving0', V().formatEUR(Math.round(basis * tier.pct / 100)));
    slot(root, 'missing0', nx ? V().formatEUR(nx.missingCents) : '');
    var pr = nx ? Math.max(4, Math.min(100, Math.round(basis / (nx.min * 100) * 100))) : 100;
    $$('[data-vip-slot="progress"]', root).forEach(function (el) { el.style.width = pr + '%'; });
    var flags = { active: true, hasnext: !!nx, top: !nx, gift: !!p.gift, t1: true };
    setShow(root, flags);
  }
  function renderCart(cart, detail) {
    if (!V()) return;
    var p = V().phase();
    var basis = detail && typeof detail.basisCents === 'number' ? detail.basisCents : V().cartBasisCents(cart || V().cart);
    $$('[data-vip-el="cart"]').forEach(function (root) { try { fillCart(root, p, basis); } catch (e) { console.warn('[VIP] cart render', e); } });
    $$('[data-vip-root]').forEach(highlightChips);
  }

  /* ---------- Staffel-Modal ---------- */
  var modal = null, lastFocus = null, builtKey = null;
  function modalEl() { return modal || (modal = document.getElementById('vip-tier-modal')); }
  function buildModal(p) {
    var m = modalEl(); if (!m) return;
    var key = p.key + '|' + (p.active ? 'a' : 'i');
    var table = m.querySelector('[data-vip-slot="table"]');
    slot(m, 'datespan', dateSpan());
    slot(m, 'giftdays', giftDays());
    slot(m, 'pwdays', passwordDays());
    slot(m, 'openday', openDay());
    slot(m, 'giftmin', eur0((V().config.gift && V().config.gift.threshold) || 1000));
    if (!table || builtKey === key) return;
    builtKey = key;
    var ph = V().phases || [];
    var cols = (ph[0] && ph[0].tiers) || [];
    var nowTs = V().now().getTime();
    // Markus 20.10.: vergangene Phasen ausblenden (nicht nur ausgrauen); die aktuelle Phase bleibt immer sichtbar
    var rows = ph.filter(function (x) {
      if (p.active && x.key === p.key) return true;
      return !((x.untilAt || x.endAt) <= nowTs);
    });
    var html = '<div class="vip-tt__row vip-tt__row--head" role="row"><div class="vip-tt__name" role="columnheader">Phase</div>';
    cols.forEach(function (t, i) { html += '<div class="vip-tt__cell" role="columnheader">' + esc(tierRange(cols, i)).replace(/ /g, '&nbsp;') + '</div>'; });
    html += '</div>';
    if (!rows.length) {
      html += '<div class="vip-tt__row vip-tt__row--empty" role="row"><div class="vip-tt__name" role="cell"><b>Der VIP Sale ist beendet.</b></div></div>';
    }
    rows.forEach(function (x, idx) {
      var cur = p.active && x.key === p.key;
      var next = !p.active && idx === 0;
      var cls = 'vip-tt__row' + (cur ? ' is-current' : '') + (next ? ' is-next' : '');
      html += '<div class="' + cls + '" role="row"' + (cur ? ' aria-current="true"' : '') + '>';
      html += '<div class="vip-tt__name" role="rowheader"><span class="vip-tt__line"><b>' + esc(label(x)) + '</b>' +
        (cur ? '<span class="vip-tt__now">Jetzt</span>' : (next ? '<span class="vip-tt__now vip-tt__now--next">Als Nächstes</span>' : '')) + '</span>' +
        '<span class="vip-tt__when">' + esc(phaseWhen(x)) + '</span></div>';
      cols.forEach(function (c) {
        var hit = null;
        (x.tiers || []).forEach(function (t) { if (t.min === c.min) hit = t; });
        html += '<div class="vip-tt__cell" role="cell"><b>' + (hit ? esc(pct(hit.pct)) : '–') + '</b></div>';
      });
      html += '</div>';
    });
    table.innerHTML = html;
  }
  function focusables(m) {
    return $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', m).filter(function (el) { return el.offsetParent !== null; });
  }
  function openModal(opener) {
    var m = modalEl(); if (!m) return;
    if (V()) buildModal(V().phase());
    lastFocus = opener || document.activeElement;
    m.hidden = false;
    document.documentElement.classList.add('vip-modal-open');
    var panel = m.querySelector('.vip-modal__panel');
    setTimeout(function () { try { (m.querySelector('.vip-modal__close') || panel).focus({ preventScroll: true }); } catch (e) {} }, 30);
  }
  function closeModal() {
    var m = modalEl(); if (!m || m.hidden) return;
    m.hidden = true;
    document.documentElement.classList.remove('vip-modal-open');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    lastFocus = null;
  }
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var o = e.target.closest('[data-vip-open-tiers]');
    if (o) { e.preventDefault(); openModal(o); return; }
    var c = e.target.closest('[data-vip-close-tiers]');
    if (c) { e.preventDefault(); closeModal(); }
  });
  document.addEventListener('keydown', function (e) {
    var m = modalEl(); if (!m || m.hidden) return;
    if (e.key === 'Escape' || e.keyCode === 27) { e.preventDefault(); closeModal(); return; }
    if (e.key === 'Tab' || e.keyCode === 9) {
      var f = focusables(m); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !m.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Inline-Anmeldung (gleiche Logik wie sections/mh-vip-popup.liquid) ---------- */
  var SU_KEY_DONE = 'mhvp_done', SU_REVISION = '2025-07-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function popupEl() { return document.getElementById('mh-vip-popup'); }
  function popupText(sel) { var p = popupEl(), n = p && p.querySelector(sel); return n ? (n.textContent || '').trim() : ''; }
  function signupSync(box) {
    // Texte (Erfolg, Fehler, Fußzeile) 1:1 aus dem Popup übernehmen – eine Quelle (Theme-Editor), Liquid-Texte sind nur Fallback
    if (!box.__vipSuInit) {
      box.__vipSuInit = true;
      var t;
      if ((t = popupText('.mhvp__success h3'))) txt(box.querySelector('[data-vip-signup-ok-title]'), t);
      if ((t = popupText('.mhvp__success p'))) txt(box.querySelector('[data-vip-signup-ok-text]'), t);
      if ((t = popupText('.mhvp__err'))) txt(box.querySelector('[data-vip-signup-err]'), t);
      if ((t = popupText('.mhvp__foot'))) txt(box.querySelector('[data-vip-signup-foot]'), t);
    }
    var done = lsGet(SU_KEY_DONE) === '1';
    box.classList.toggle('is-success', done);
    var ok = box.querySelector('[data-vip-signup-ok]'), form = box.querySelector('[data-vip-signup-form]'), note = box.querySelector('.vip-signup__note'), lead = box.querySelector('.vip-signup__lead');
    if (ok) ok.hidden = !done;
    if (lead) lead.hidden = done;
    if (form) form.hidden = done;
    if (note) note.hidden = done;
  }
  function signupSubscribe(email) {
    var p = popupEl();
    var list = p && p.getAttribute('data-list'), company = p && p.getAttribute('data-company');
    var source = (p && p.getAttribute('data-source')) || 'VIP Early Access Popup';
    if (!list || !company) return Promise.reject(new Error('config'));
    var body = { data: { type: 'subscription', attributes: {
      custom_source: source,
      profile: { data: { type: 'profile', attributes: { email: email, properties: { 'VIP Early Access': 'ja' } } } }
    }, relationships: { list: { data: { type: 'list', id: list } } } } };
    return (nativeFetch || window.fetch).call(window, 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST', keepalive: true,
      headers: { 'content-type': 'application/json', revision: SU_REVISION },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); return true; });
  }
  function signupError(box, on) {
    var err = box.querySelector('[data-vip-signup-err]'), inp = box.querySelector('.vip-signup__input');
    box.classList.toggle('is-error', on);
    if (err) err.hidden = !on;
    if (inp) inp.setAttribute('aria-invalid', on ? 'true' : 'false');
  }
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-vip-signup-form]') : null;
    if (!form) return;
    e.preventDefault();
    var box = form.closest('[data-vip-signup]'); if (!box) return;
    var inp = form.querySelector('.vip-signup__input'), btn = form.querySelector('button[type="submit"]');
    var email = (inp.value || '').trim();
    signupError(box, false);
    if (!EMAIL_RE.test(email)) { signupError(box, true); try { inp.focus(); } catch (err) {} return; }
    btn.disabled = true;
    signupSubscribe(email).then(function () {
      lsSet(SU_KEY_DONE, '1');
      try { window._learnq = window._learnq || []; window._learnq.push(['identify', { $email: email }]); } catch (err) {}
      $$('[data-vip-signup]').forEach(signupSync);
      var p = popupEl(); if (p) p.classList.add('is-success'); // Popup zeigt danach ebenfalls „Du bist dabei!“
    }).catch(function () {
      signupError(box, true);
    }).then(function () { btn.disabled = false; });
  });
  document.addEventListener('input', function (e) {
    var inp = e.target;
    if (!inp || !inp.classList || !inp.classList.contains('vip-signup__input')) return;
    var box = inp.closest('[data-vip-signup]');
    if (box && box.classList.contains('is-error')) signupError(box, false);
  });

  /* ---------- Start ---------- */
  function boot() {
    if (!V()) { console.warn('[VIP] vip-banner.js: window.VIP fehlt'); $$('[data-vip-root]').forEach(function (r) { r.hidden = true; }); return; }
    $$('[data-vip-signup]').forEach(signupSync);
    V().onPhase(function () { renderPhase(); });
    V().onCart(function (cart, detail) { renderCart(cart, detail); });
    tick();
    setInterval(tick, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  window.VIPBanner = { __init: true, render: renderPhase, renderCart: renderCart, openTiers: openModal, closeTiers: closeModal, label: label, tiersLine: tiersLine };
})();
